import { makePost, makeGet } from 'src/utils/api-helpers'

    export const fetchPlansWithOffreID = ( offreID, opts )=>makeGet(`/api/offres/${offreID}/plans`, opts);

    export const fetchUserBillingAddress = ( userID, opts )=>makeGet(`/api/users/${userID}/billingAddress`, opts);

    export const fetchPlansWithOffreIDAndUserID = ( offreID, userID, opts )=>
        makeGet(`/api/offres/${offreID}/users/${userID}`, opts);

    export const fetchPlansByOffreID = ( offreID, opts )=>makeGet(`/api/plans/offres/${offreID}`, opts);

    export const fetchAllOffres = ( opts )=> makeGet(`/api/offres/subscription/all`, opts);

    export const fetchAllPlan = ( opts )=>makeGet(`/api/plans`, opts);

    export const fetchPlan = ( planID, opts )=>makeGet(`/api/plans/${planID}`, opts);

    export const fetchOfferWithUserID = ( userID, opts )=>makeGet(`/api/offres/users/${userID}/belongingNot`, opts);

    export const fetchOfferWithUser = ( userID, opts )=>makeGet(`/api/offres/users/${userID}`, opts);

    export const fetchOrganization = ( opts )=>makeGet(`/api/subscriptions/organization`, opts);

    export const fetchSubscriptionWithUserID = (userID, opts) =>
        makeGet(`/api/subscriptions/users/${userID}/data`, opts);

    export const fetchAllInvoices= ( opts ) =>
        makeGet(`/api/subscriptions/invoices`, opts);


    export const sendMail = (payload, opts) =>makePost('/api/subscriptions/send-mail', payload, opts);

    export const changeDefaultOffer = (payload, opts) =>makePost('/api/offres/default', payload, opts);

    export const deleteOffer = (payload, opts) =>makePost('/api/offres/delete', payload, opts);

    export const savePlan = (payload, opts) =>makePost('/api/plans/save', payload, opts);

    export const deletePlan = (payload, opts) =>makePost('/api/plans/delete', payload, opts);

    export const saveOffre = (payload, opts) =>makePost('/api/offres/save', payload, opts);

    export const makeOfferVisible = (payload, opts) =>makePost('/api/subscriptions/visibility', payload, opts);

    export const deleteOffreWithUserID = (payload, opts) =>makePost('/api/offres/share/delete', payload, opts);

    export const shareOffre = (payload, opts) =>makePost('/api/offres/share', payload, opts);

    export const sharePlan = (payload, opts) =>makePost('/api/plans/share', payload, opts);

    export const saveDiscount = (payload, opts) =>makePost('/api/discounts/save', payload, opts);

    export const duplicateOffer = (payload, opts) =>makePost('/api/offres/duplicate', payload, opts);

    export const duplicatePlan = (payload, opts) =>makePost('/api/plans/duplicate', payload, opts);

    export const subscription = (payload, opts) =>makePost('/api/subscriptions', payload, opts);

    export const deleteOffreByOrgID = (payload, opts) =>makePost('/api/offres/delete/organization', payload, opts);

    export const gocardlessBillingRequest = (payload, opts) =>makePost('/api/gocardless/billing-request/start', payload, opts);

    export const completeBillingRequest = (payload, opts) =>makePost('/api/gocardless/billing-request/complete', payload, opts);


